"use strict";

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.array.index-of.js");

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.object.define-property.js");

require("core-js/modules/es.array.filter.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.object.get-own-property-descriptor.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.object.get-own-property-descriptors.js");

require("core-js/modules/es.object.define-properties.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _ImageWMS = _interopRequireDefault(require("ol/source/ImageWMS"));

var _TileWMS = _interopRequireDefault(require("ol/source/TileWMS"));

var _OSM = _interopRequireDefault(require("ol/source/OSM"));

var _Group = _interopRequireDefault(require("ol/layer/Group"));

var _Window = _interopRequireDefault(require("../../base/Window/Window"));

var _EditDefaultLayerForm = _interopRequireDefault(require("../../../form/layer/edit/EditDefaultLayerForm/EditDefaultLayerForm"));

var _EditImageWMSLayerForm = _interopRequireDefault(require("../../../form/layer/edit/EditImageWMSLayerForm/EditImageWMSLayerForm"));

var _EditTileWMSLayerForm = _interopRequireDefault(require("../../../form/layer/edit/EditTileWMSLayerForm/EditTileWMSLayerForm"));

var _EditOSMLayerForm = _interopRequireDefault(require("../../../form/layer/edit/EditOSMLayerForm/EditOSMLayerForm"));

var _jsxRuntime = require("react/jsx-runtime");

var _excluded = ["title", "visible", "onOk", "layer"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var LayerWnd = function LayerWnd(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? "Layer" : _ref$title,
      _ref$visible = _ref.visible,
      visible = _ref$visible === void 0 ? false : _ref$visible,
      onOk = _ref.onOk,
      layer = _ref.layer,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  var createLayerForm = function createLayerForm() {
    if (layer instanceof _Group.default) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_EditDefaultLayerForm.default, {
        layer: layer,
        onFinish: onOk
      });
    } else if (layer.getSource() instanceof _ImageWMS.default) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_EditImageWMSLayerForm.default, {
        layer: layer,
        onFinish: onOk
      });
    } else if (layer.getSource() instanceof _TileWMS.default) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_EditTileWMSLayerForm.default, {
        layer: layer,
        onFinish: onOk
      });
    } else if (layer.getSource() instanceof _OSM.default) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_EditOSMLayerForm.default, {
        layer: layer,
        onFinish: onOk
      });
    }

    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_EditDefaultLayerForm.default, {
      layer: layer,
      onFinish: onOk
    });
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Window.default, _objectSpread(_objectSpread({
    title: title,
    collapsible: true //onOk={onOk}
    ,
    visible: visible
  }, otherProps), {}, {
    children: createLayerForm()
  }));
};

var _default = LayerWnd;
exports.default = _default;